module.exports = __webpack_public_path__ + "img/3acc3e71-81b9-4f96-9aca-99e5471640a8.ce1fc776.png";